export const routerPath = {
  root: '/progressLevels',
  link: '/settings/progressLevels',
};

export const getColumns = ({ editItem }) => [
  {
    id: 'mediaID',
    type: 'avatar',
    label: 'Icon',
    align: 'left',
    disableSort: 'true',
  },
  { id: 'name', label: 'Level', align: 'center' },
  { id: 'pointLevel', label: 'Required Point Level', align: 'center' },
  { id: 'coinRewards', label: 'Level Coin Rewards', align: 'center' },
  {
    id: 'more-menu',
    type: 'menu',
    items: [{ id: 'edit', name: 'Edit', action: editItem, icon: 'eva:edit-fill' }],
    disableSort: true,
  },
];
